/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_Tile_Login_SubtitleInputs */

const en_home_hero_tile_login_subtitle = /** @type {(inputs: Home_Hero_Tile_Login_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already activated? Access your account`)
};

const fr_home_hero_tile_login_subtitle = /** @type {(inputs: Home_Hero_Tile_Login_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déjà activé ? Accédez à votre compte`)
};

/**
* | output |
* | --- |
* | "Already activated? Access your account" |
*
* @param {Home_Hero_Tile_Login_SubtitleInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_hero_tile_login_subtitle = /** @type {((inputs?: Home_Hero_Tile_Login_SubtitleInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_Tile_Login_SubtitleInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_hero_tile_login_subtitle(inputs)
	return fr_home_hero_tile_login_subtitle(inputs)
});